import React from "react"

import "./aside-mobile-filter-subcategory.scss"
import FilterMultiCheckImg from "../../atoms/filter-multi-check-img/filter-multi-check-img"
import FilterMultiCheck from "../../atoms/filter-multi-check/filter-multi-check"

const AsideMobileFilterSubcategory = props => {
  const [curtain, setCurtain] = React.useState(false)

  React.useEffect(() => {
    setCurtain(true)
    document.body.style.overflow = "hidden"
  }, [])

  const handleClose = () => {
    setCurtain(false)

    setTimeout(() => {
      props.setModalActive(null)
    }, 200)
  }
  const opcionExist = opcionExist => {
    if (opcionExist) {
      return opcionExist.length
    }
    return 0
  }

  const {
    segundoFiltro,
    tercerFiltro,
    cuartoFiltro,
    quintoFiltro,
    sextoFiltro,
    septimoFiltro,
    opcionesSegundoFiltro,
    opcionesTercerFiltro,
    opcionesCuartoFiltro,
    opcionesQuintoFiltro,
    opcionesSextoFiltro,
    opcionesSeptimoFiltro,
  } = props.filter

  return (
    <aside
      className={"f-aside-nav-filter " + (curtain ? "f-active-curtain" : "")}
    >
      <div
        className={
          "f-elements-container " + (curtain ? "f-elements-active" : "")
        }
      >
        <p className="f-aside-nav-filter-copy">Filtrar por:</p>
        <div className="f-filters-container">
          {(segundoFiltro && (props.productTitle !== 'Protectores Diarios' || process.env.LOCALE !== 'es-CO')) && (
            <FilterMultiCheckImg
              activeFilters={props.activeFilters}
              title={segundoFiltro}
              options={opcionesSegundoFiltro}
              handleChangeFilter={props.handleChangeFilter}
              numfilter={1}
            />
          )}
          {tercerFiltro && (
            <FilterMultiCheck
              activeFilters={props.activeFilters}
              title={tercerFiltro}
              options={opcionesTercerFiltro}
              handleChangeFilter={props.handleChangeFilter}
              numfilter={opcionExist(opcionesSegundoFiltro) + 1}
            />
          )}
          {cuartoFiltro && (
            <FilterMultiCheck
              activeFilters={props.activeFilters}
              title={cuartoFiltro}
              options={opcionesCuartoFiltro}
              handleChangeFilter={props.handleChangeFilter}
              numfilter={
                opcionExist(opcionesSegundoFiltro) +
                opcionExist(opcionesTercerFiltro) +
                1
              }
            />
          )}
          {quintoFiltro && (
            <FilterMultiCheck
              activeFilters={props.activeFilters}
              title={quintoFiltro}
              options={opcionesQuintoFiltro}
              handleChangeFilter={props.handleChangeFilter}
              numfilter={
                opcionExist(opcionesSegundoFiltro) +
                opcionExist(opcionesTercerFiltro) +
                opcionExist(opcionesCuartoFiltro) +
                1
              }
            />
          )}
          {(sextoFiltro && (props.productTitle !== 'Protectores Diarios' || process.env.LOCALE !== 'es-CO')) && (
            <FilterMultiCheck
              activeFilters={props.activeFilters}
              title={sextoFiltro}
              options={opcionesSextoFiltro}
              handleChangeFilter={props.handleChangeFilter}
              numfilter={
                opcionExist(opcionesSegundoFiltro) +
                opcionExist(opcionesTercerFiltro) +
                opcionExist(opcionesCuartoFiltro) +
                opcionExist(opcionesQuintoFiltro) +
                1
              }
            />
          )}
          {(septimoFiltro && process.env.LOCALE !== 'es-CO') && (
            <FilterMultiCheckImg
              activeFilters={props.activeFilters}
              title={septimoFiltro}
              options={opcionesSeptimoFiltro}
              handleChangeFilter={props.handleChangeFilter}
              numfilter={
                opcionExist(opcionesSegundoFiltro) +
                opcionExist(opcionesTercerFiltro) +
                opcionExist(opcionesCuartoFiltro) +
                opcionExist(opcionesQuintoFiltro) +
                opcionExist(opcionesSextoFiltro) +
                1
              }
            />
          )}
          <div className="f-fake-button" onClick={() => handleClose()}>
            Filtrar
          </div>
          <span
            className="f-icon icon2-close f-icon-close"
            onClick={() => handleClose()}
          />
        </div>
      </div>
    </aside>
  )
}

export default AsideMobileFilterSubcategory
